import { ActionIcon, Menu, Text } from "@mantine/core"
import {
  IconDownload,
  IconDotsVertical,
  IconFileArrowLeft,
} from "@tabler/icons-react"
import { DocumentDownload } from "@tfg/ui"

import { FindIngestionsResponseDto } from "~/gen/api"
import { fetchDocumentUrl } from "~/hooks/useDocumentsQuery"

type IngestionActionsMenuProps = {
  row: {
    original: FindIngestionsResponseDto
  }
  handleErrorModalOpen: (ingestionId: string) => void
}

export const IngestionActionsMenu: React.FC<IngestionActionsMenuProps> = ({
  row,
  handleErrorModalOpen,
}: IngestionActionsMenuProps) => {
  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <ActionIcon variant="ghost">
          <IconDotsVertical />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {row.original.status === "ERROR" ? (
          <>
            <Menu.Item
              leftSection={<IconFileArrowLeft />}
              onClick={() => handleErrorModalOpen(row.original.id)}
            >
              <Text fz="sm">Show error logs</Text>
            </Menu.Item>
          </>
        ) : null}

        <Menu.Item leftSection={<IconDownload />}>
          <DocumentDownload
            documentName={row.original.document.originalFileName ?? ""}
            showAsText={true}
            customText="Download product import file"
            fetchDownloadUrl={() =>
              fetchDocumentUrl(row.original.document.id, true)
            }
          />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
